// let swatchElements = document.querySelectorAll('.collection_swatches');
// let firstSwatch = swatchElements[0];

let titles = [];
let productDataObjects = [];
let swatchData = document
  .querySelector('#swatch-data')
  .getAttribute('data-hex_data');
let swatchHexColors = swatchData.split(',');

// console.log('Swatch colors: ', swatchHexColors);

function getSwatchElements() {
  return document.querySelectorAll('.collection_swatches');
}
let swatchElements = getSwatchElements();

function splitSwatchData() {
  let swatchData = document
    .querySelector('#collection-data')
    .getAttribute('collection-data');

  // separate by product
  let dataStrings = swatchData.split('^^');
  dataStrings.pop();

  for (let dataString of dataStrings) {
    //separate title from data
    let productData = dataString.split(' | ');
    for (let product in productData) {
      product % 2 == 0
        ? titles.push(productData[product])
        : productDataObjects.push(productData[product]);
    }
  }
}
splitSwatchData();

function splitProductData(data) {
  // Separate all products
  let allProductData = data.split(':::');
  let returnData = [];
  for (let singleProductData of allProductData) {
    let sizeSplit = singleProductData.split('-SIZES-');
    let sizeData = '-SIZES-' + sizeSplit[1];
    let productData = sizeSplit[0];
    let productDataSplit = productData.split('::');
    let loopTempArr = [];
    for (let dataSplit of productDataSplit) {
      loopTempArr.push(dataSplit);
    }
    loopTempArr.push(sizeData);
    returnData.push(loopTempArr);
    // console.log('Size data: ', sizeData);
  }
  return returnData;
}

function createSrcSet(url) {
  console.log('Url to split: ', url);
  let widths = ['200', '400', '600'];
  let srcSet = '';
  let urlSplit = url.split('?');
  let split = urlSplit[0];
  let fileSuffix = split.substring(split.length - 4, split.length);
  let first = split.substring(0, split.length - 4);

  for (let width of widths) {
    srcSet += `${first}_${width}x${fileSuffix}?${urlSplit[1]} ${width}w,`;
  }

  return srcSet;
}

//
function createElements(swatchElement, data) {
  let extractedSwatchData = splitProductData(data);

  for (let extractedData of extractedSwatchData) {
    let isPrimary = false;
    let pid = extractedData[0];
    let p_url = extractedData[1];
    let color = extractedData[2];
    let image1Url = extractedData[3];
    let image1Srcset = createSrcSet(image1Url);
    let image2Url = extractedData[4];
    let image2Srcset = createSrcSet(image2Url);
    let waitlist = extractedData[5];
    let swatchUrl = extractedData[6];
    let p_price = extractedData[7];
    if (parseInt(p_price) > 999) {
      p_price = parseInt(p_price) / 100;
    }
    let sizeData = extractedData[8];
    // check productId match for primary/c_active
    let card = swatchElement.closest('.thumbnail');
    let cardColor = card.querySelector('.variant-color').innerText;
    if (color === cardColor) {
      isPrimary = true;
    }

    let newNode = document.createElement('div');
    newNode.setAttribute('product_data', extractedData);
    newNode.classList.add('swatch-element', 'custom_available');
    if (isPrimary) newNode.classList.add('c_active');
    // newNode.innerText = 'HELLS YEAH';

    let toolTip = document.createElement('div');
    toolTip.classList.add('tooltip', 'hide');
    toolTip.innerText = color;
    newNode.appendChild(toolTip);

    let label = document.createElement('label');
    label.setAttribute('data-product_url', p_url);
    label.setAttribute('data-product_id', pid);
    label.classList.add('swatch', 'selector');
    if (isPrimary == true) {
      label.setAttribute('data-primary', true);
      label.classList.add('c_active');
    }
    label.setAttribute('data-product-title', 'p.title');
    label.setAttribute('data-swatch-color', color);
    label.setAttribute('data-card-color', cardColor);
    label.setAttribute('data-first-img-url', image1Url);
    label.setAttribute('data-first-img-srcset', image1Srcset);
    label.setAttribute('data-second-img-url', image2Url);
    label.setAttribute('data-second-img-srcset', image2Srcset);
    // label.setAttribute('loading', 'lazy');
    if (waitlist == true) {
      label.setAttribute('waitlist', '');
    }
    label.setAttribute('data-price', p_price);
    label.setAttribute('data-sizes', sizeData);

    // set image and color attributes
    let span = document.createElement('span');
    let hasHexColor = false;
    for (let swatchColor of swatchHexColors) {
      let colorHandle = color.toLowerCase().replace(' ', '-');
      if (swatchColor == colorHandle) hasHexColor = true;
    }
    !hasHexColor ? (span.style.backgroundImage = `url(${swatchUrl})`) : '';
    let backgroundColor = color
      .toLowerCase()
      .replaceAll(' ', '-')
      .replaceAll('/', '-');
    span.style.backgroundColor = `var(--${backgroundColor})`;
    // console.log('Color: ', color);
    // console.log('Background color: ', backgroundColor);

    label.appendChild(span);
    newNode.appendChild(label);

    swatchElement.appendChild(newNode);
  }
}

function fillMissingSwatches() {
  let startNum = 0;
  if (numOfCards < getProductCards().length) startNum = numOfCards++;

  swatchElements = getSwatchElements();
  //   for (let i in swatchElements) {
  //     if (i < startNum) {
  //       continue;
  //     } else {
  //       for (let title of titles) {
  //         for (let swatchElement of swatchElements) {
  //           let productHandle = swatchElement.getAttribute('product_handle');

  //           if (title == productHandle && swatchElement.children.length === 0) {
  //             const dataIndex = titles.indexOf(title);
  //             createElements(swatchElement, productDataObjects[dataIndex]);
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  for (let title of titles) {
    for (let swatchElement of swatchElements) {
      let productHandle = swatchElement.getAttribute('product_handle');

      if (title == productHandle && swatchElement.children.length === 0) {
        const dataIndex = titles.indexOf(title);
        createElements(swatchElement, productDataObjects[dataIndex]);
      }
    }
  }
}

if (!swatchElements[0].querySelector('.swatch-element')) {
  fillMissingSwatches();
}

// Observe product cards container for new elements to add swatches (infinite scroll)
const productCardWrapper = document.querySelector('.product-list');

const observer = new MutationObserver((mutations, observer) => {
  let newCards = getProductCards();
  // console.log(mutations, observer);
  console.log('Filling dem elements, boss');
  // from product-variant-swatches.js
  console.log('Filling new swatches');
  fillMissingSwatches();
  // console.log('Supposedly setting primary image');
  setPrimaryImage(newCards);
  // console.log('I may be creating the image elements');
  createImageElements(newCards);
});

observer.observe(productCardWrapper, {
  attributes: false,
  childList: true,
  subtree: false
});

// Set starting num & run standard for-loop to limit work
